import { render, staticRenderFns } from "./Latest-Debates.vue?vue&type=template&id=65a4883c&scoped=true&"
import script from "./Latest-Debates.vue?vue&type=script&lang=js&"
export * from "./Latest-Debates.vue?vue&type=script&lang=js&"
import style0 from "./Latest-Debates.vue?vue&type=style&index=0&id=65a4883c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a4883c",
  null
  
)

export default component.exports